import { selectIsConfirmationSuccessModalOpen } from 'features/common/model/selectors/appSelectors'
import {
  AUTH_MODAL_MODE,
  setAuthModalMode,
  setIsAuthModalOpen,
  setIsConfirmationSuccessModalOpen
} from 'features/common/model/slice/appSlice'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'shared/config/store'
import { Button, Flex, Modal, Typography } from 'shared/ui'
import styled from 'styled-components'

import { CheckCircleFilled } from '../../../shared/ui'

export const ConfirmationByLinkSuccessModal = () => {
  const isConfirmationByLinkSuccessModalOpen = useAppSelector(selectIsConfirmationSuccessModalOpen)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const handleClose = () => {
    return false
  }

  const handleGoToSignIn = () => {
    navigate('/')
    dispatch(setIsConfirmationSuccessModalOpen(false))
    dispatch(setAuthModalMode(AUTH_MODAL_MODE.SIGNIN))

    dispatch(setIsAuthModalOpen(true))
  }


  return (
    <Modal
      open={isConfirmationByLinkSuccessModalOpen}
      footer={null}
      width={420}
      closable={false}
      centered
      destroyOnClose={true}
      onCancel={handleClose}
      styles={{
        mask: {
          backgroundColor: "transparent",
          background: "url('/images/sendToEmailBg.svg')",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
        },
        content: {
          padding: 48,
        },
      }}
      wrapClassName="signup-confirmation-modal-wrapper"
    >
      <Flex vertical
        align="center"
        gap={24}
      >
        <SuccessIcon>
          <CheckCircleFilled style={{ fontSize: 60, color: "#52c41a" }} />
        </SuccessIcon>

        <Typography.Title level={3}
          style={{
            textAlign: "center",
            margin: 0,
            color: "rgba(0, 0, 0, 0.85)",
            fontSize: 24,
            fontWeight: 600,
            lineHeight: "32px" }}
        >
          Your Account Confirmed
        </Typography.Title>

        <Typography.Text style={{
          textAlign: "center",
          color: "rgba(0, 0, 0, 0.65)",
          fontSize: 14,
          lineHeight: "22px" }}
        >
          You’re all set! Your account has been successfully confirmed. Use the button below to sign in and  start managing your digital assets.
        </Typography.Text>

        <Button
          type="primary"
          block
          size="large"
          style={{ fontSize: 16, height: 40 }}
          onClick={handleGoToSignIn}
        >
          Go to Sign In
        </Button>
      </Flex>
    </Modal>
  )
}

const SuccessIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 72px;
  height: 72px;
  margin-bottom: 8px;
  padding: 4px;
  box-sizing: border-box;
`

const SignUpLink = styled.span`
  color: #8F4EEB;
  cursor: pointer;
  text-decoration: underline;
`
